import { StaticTextContext } from '@/components/context/StaticTextProvider';
import { GridRow } from '@/components/ui/layouts/grids/GridRow';
import { HighlightSection } from '@/components/ui/layouts/sections/HighlightSection';
import { Modal } from '@/components/ui/overlays/modal/Modal';
import { useContext } from 'react';
import { useState } from 'react';
import { Instances } from '../Instances';

export const ImageGalleryBlock = ({ data }) => {
  const { st } = useContext(StaticTextContext);
  const [selectedId, setSelectedId] = useState(null);

  const handleOpen = (item) => {
    setSelectedId(item.meta?.id);
  };

  const handleClose = () => {
    setSelectedId(null);
  };

  const selectedInstance = data?.relations?.ImageGalleryList?.find(
    (item) => item.meta?.id === selectedId,
  );

  return (
    <HighlightSection
      heading={{
        epi: data?.fields?.epi,
        title: data?.fields?.title,
        meta_info: data?.fields?.meta_info,
      }}
    >
      <GridRow>
        <Instances
          onClick={handleOpen}
          instances={data?.relations?.ImageGalleryList}
        />
      </GridRow>
      <Modal
        opened={!!selectedId}
        onClose={handleClose}
        texts={{ close: st('header.close') }}
      >
        {selectedInstance && (
          <Instances instances={[selectedInstance]} isThumbnail={true} />
        )}
      </Modal>
    </HighlightSection>
  );
};
